import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.25 21.007v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v4.875m0 0h4.5V3.552m-4.5 17.455h7.5v-10.25m-18 10.25h1.5m18 0h-18m-1.5-12 4.5-1.636m12-4.364-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.371V3.007h-3v18m3-13.636 10.5-3.819"
    }, null, -1)
  ])))
}
export default { render: render }